import { render, staticRenderFns } from "./supplierBMag.vue?vue&type=template&id=5e355fe5&scoped=true&"
import script from "./supplierBMag.vue?vue&type=script&lang=js&"
export * from "./supplierBMag.vue?vue&type=script&lang=js&"
import style0 from "./supplierBMag.vue?vue&type=style&index=0&id=5e355fe5&scoped=true&lang=css&"
import style1 from "./supplierBMag.vue?vue&type=style&index=1&id=5e355fe5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e355fe5",
  null
  
)

export default component.exports